const AnalysisEndpoints = {
  GET_ANALYSIS_LIST: (workspaceId: string | null) => `/analyses/?workspace_id=${workspaceId}`,
  EXECUTE_ANALYSIS: "/analyses/",
  DOWNLOAD_CSV: (analysisId: string, categoryPath?: string) => {
    const baseUrl = `/analyses/${analysisId}/download/`;
    return categoryPath ? `${baseUrl}?category_path=${categoryPath}` : baseUrl;
  },
  GET_ANALYSIS_VOCS: (analysisId: string) => `/analyses/${analysisId}/vocs/`,
  CHAT: (analysisId: string) => `/analyses/${analysisId}/chat/`,
};

export default AnalysisEndpoints;
